"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockApi3ServerV1OevExtensionOevBidPayer__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "initialOwner",
                type: "address",
            },
            {
                internalType: "address",
                name: "api3ServerV1OevExtension_",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        inputs: [],
        name: "api3ServerV1OevExtension",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "bidAmount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "onOevBidPayment",
        outputs: [
            {
                internalType: "bytes32",
                name: "oevBidPaymentCallbackSuccess",
                type: "bytes32",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "dappId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "bidAmount",
                type: "uint256",
            },
            {
                internalType: "uint32",
                name: "signedDataTimestampCutoff",
                type: "uint32",
            },
            {
                internalType: "bytes",
                name: "signature",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "payOevBid",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "dappId",
                type: "uint256",
            },
            {
                internalType: "bytes[]",
                name: "signedData",
                type: "bytes[]",
            },
        ],
        name: "updateDappOevDataFeed",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class MockApi3ServerV1OevExtensionOevBidPayer__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(initialOwner, api3ServerV1OevExtension_, overrides) {
        return super.getDeployTransaction(initialOwner, api3ServerV1OevExtension_, overrides || {});
    }
    deploy(initialOwner, api3ServerV1OevExtension_, overrides) {
        return super.deploy(initialOwner, api3ServerV1OevExtension_, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.MockApi3ServerV1OevExtensionOevBidPayer__factory = MockApi3ServerV1OevExtensionOevBidPayer__factory;
//# sourceMappingURL=MockApi3ServerV1OevExtensionOevBidPayer__factory.js.map